import fetchFactory from '../../../../utils/fetchFactory'
import { configEnum } from '../../../../enums/fetchFactoryEnum'

export const getLastRequestUser = (token: string) => fetchFactory('/api/ec_residence/demande_residentielle/getLastRequestUser', { method: configEnum.post, body: token })